export { default } from './SolidBadge';
